import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Select, Input, Button, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRobot } from '@fortawesome/free-solid-svg-icons'

const { TextArea } = Input
const { Title } = Typography

const AIGenerateModal = ({ visible, onCancel, onGenerate }) => {
  const [language, setLanguage] = useState('English')
  const [additionalPrompt, setAdditionalPrompt] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleGenerate = async () => {
    setIsLoading(true)
    try {
      await onGenerate({ language, additionalPrompt })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      title={
        <Space>
          <FontAwesomeIcon icon={faRobot} />
          <span>Generate AI Clinical Notes</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key='cancel' onClick={onCancel}>
          Cancel
        </Button>,
        <Button key='generate' type='primary' onClick={handleGenerate} loading={isLoading}>
          Generate Notes
        </Button>
      ]}
      width={600}
    >
      <Space direction='vertical' style={{ width: '100%', marginTop: 16 }}>
        <div>
          <Title level={5}>Language</Title>
          <Select
            style={{ width: '100%' }}
            value={language}
            onChange={setLanguage}
            options={[
              { value: 'English', label: 'English' },
              { value: 'Spanish', label: 'Spanish' },
              { value: 'French', label: 'French' },
              { value: 'German', label: 'German' },
              { value: 'Italian', label: 'Italian' },
              { value: 'Portuguese', label: 'Portuguese' },
              { value: 'Dutch', label: 'Dutch' },
              { value: 'Russian', label: 'Russian' },
              { value: 'Chinese', label: 'Chinese' },
              { value: 'Japanese', label: 'Japanese' },
              { value: 'Arabic', label: 'Arabic' },
              { value: 'Hindi', label: 'Hindi' }
            ]}
          />
        </div>
        <div style={{ marginTop: 16 }}>
          <Title level={5}>Additional Instructions (Optional)</Title>
          <TextArea
            placeholder="Add specific instructions for the AI, e.g., 'Focus on cardiac symptoms' or 'Include detailed medication recommendations'"
            value={additionalPrompt}
            onChange={(e) => setAdditionalPrompt(e.target.value)}
            rows={4}
          />
        </div>
      </Space>
    </Modal>
  )
}

AIGenerateModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired
}

export default AIGenerateModal
